<template>
  <div class="main">
    <div class="top">
      <div>
        <img :src="userInfo.headImg" />
      </div>
      <span class="nick">{{ userInfo.nickName }}</span>
    </div>
    <div class="policy-container">
      <div class="policy-menu">
        <div class="policy-lf">
          <div class="menu-item" @click="goPolicyList('waitPay')">
            <div class="menu-img">
              <img src="../../assets/img/user_center/daizhifu.png" />
            </div>
            <p>待支付</p>
          </div>
          <div class="menu-item" @click="goPolicyList('effective')">
            <div class="menu-img">
              <img src="../../assets/img/user_center/baozhangzhong.png" />
            </div>
            <p>保障中</p>
          </div>
          <div class="menu-item" @click="goPolicyList('unEffective')">
            <div class="menu-img">
              <img src="../../assets/img/user_center/yishixiao.png" />
            </div>
            <p>已失效</p>
          </div>
          <div class="menu-item" @click="goPolicyList('theEnd')">
            <div class="menu-img">
              <img src="../../assets/img/user_center/yiguanbi.png" />
            </div>
            <p>已关闭</p>
          </div>
        </div>
        <div class="policy-md"></div>
        <div class="policy-rt">
          <div class="menu-item" @click="goPolicyList('all')">
            <div class="menu-img">
              <img src="../../assets/img/user_center/wodedingdan.png" />
            </div>
            <p>我的订单</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="block-menu" @click="goBlockMenu('InsuredQuery')">
      <div class="block-img">
        <img src="../../assets/img/user_center/lipei.png" />
      </div>
      <div>参保信息查询</div>
    </div> -->
    <div class="block-menu" @click="goBlockMenu('ClaimNotice')">
      <div class="block-img">
        <img src="../../assets/img/user_center/yinsi.png" />
      </div>
      <div>理赔须知</div>
    </div>
    <div
      class="online-serve"
      v-track-event="'跳转至直播客服页面,点击,用户点击图标跳转至直播客服页面'"
      @click="goConsult"
    >
      <img src="@/assets/img/user_center/zaixiankefu.png" />
    </div>

    <div class="block-menu" @click="goBlockMenu('InsuFaq')">
      <div class="block-img">
        <img src="../../assets/img/user_center/guanyuwomen.png" />
      </div>
      <div>常见问题</div>
    </div>

    <!-- <main-menu /> -->
    <force-bind v-model="showLogin" />
  </div>
</template>

<script>
  // import MainMenu from '@/components/MainMenu'
  import ForceBind from '@/components/ForceBind'
  import { CustomerServiceLink2 } from '@/util/config'
  import { checkMobileVerify } from '@/api/insu-info'
  import { SetGetAuthInfo } from '@/util/auth'

  export default {
    name: 'UserCenter',
    components: {
      // MainMenu,
      ForceBind
    },
    mixins: [],
    props: {},

    data() {
      return {
        showLogin: false,
        userInfo: {}
      }
    },
    computed: {},
    watch: {},
    created() {
      this.getPhoneStatus()
    },
    mounted() {
      this.userInfo = SetGetAuthInfo.getInfo()
    },
    destroyed() {},
    methods: {
      async getPhoneStatus() {
        let res = await checkMobileVerify({
          openId: this.userInfo.openId
        })
        if (res) {
          // 有手机号就不用注册了
          this.$store.commit('SET_USER_INFO', false)
        } else {
          this.$store.commit('SET_USER_INFO', true)
        }
      },
      goPolicyList(type) {
        this.$router.push({ path: `/user-policy/${type || ''}` })
      },
      goBlockMenu(val) {
        this.$router.push({ name: val })
      },
      goConsult() {
        let rest = JSON.parse(localStorage.getItem('wxinfor'))
        let datainfor = {
          userNickname: rest && rest.userName ? rest.userName : '', // 微信昵称
          trueName: this.$store.state.userInfo.nickName, // 用户名
          phone:
            rest && rest.mobilePhone
              ? rest.mobilePhone
              : this.$store.state.userInfo.nickName // 手机号
        }
        datainfor.phone = datainfor.phone || '该客户未留手机号'
        localStorage.setItem('visitorinfor', JSON.stringify(datainfor))
        location.href = CustomerServiceLink2
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    width: 100%;
    height: 100vh;
    background-color: #fbfbfb;
    position: relative;
  }
  .top {
    display: flex;
    padding: px2rem(12, 375) px2rem(30, 375);
    align-items: center;
    font-size: px2rem(18, 375);
    color: #000;
    background-color: #fff;

    img {
      width: px2rem(54, 375);
      height: px2rem(54, 375);
      border-radius: px2rem(30, 375);
      border: 2px solid #fff;
      margin-right: px2rem(12, 375);
    }
  }

  .policy-container {
    width: 100%;
    background-color: #fff;
    margin: px2rem(20, 375) 0;
    padding: px2rem(12, 375);
  }

  .policy-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: px2rem(320, 370);
    max-width: 100%;
    margin: 0 auto;

    .menu-img {
      width: px2rem(26, 375);
      height: px2rem(26, 375);
      margin: 0 auto px2rem(12, 375);
      img {
        width: 100%;
      }
    }
    .policy-lf {
      flex-basis: px2percent(280, 375);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .menu-item {
      text-align: center;
      font-size: px2rem(14, 375);
      color: #4c4c4c;
      margin-top: px2rem(10, 375);
    }

    .policy-md {
      width: 2px;
      height: px2rem(45, 375);
      background-color: #f9fafc;
    }
  }

  .block-menu {
    display: flex;
    align-items: center;
    width: 100%;
    margin: px2rem(12, 375) auto;
    padding: px2rem(18, 375) px2rem(30, 375);
    font-size: px2rem(16, 375);
    color: #4c4c4c;
    background-color: #fff;

    .block-img {
      width: px2rem(20, 375);
      margin-right: px2rem(17, 375);

      img {
        width: 100%;
      }
    }
  }

  .cust-service-tel {
    margin-top: px2rem(40, 375);
    text-align: center;
    font-size: px2rem(18, 375);

    span,
    a {
      vertical-align: middle;
    }

    a {
      color: $themeColor;
    }
  }
  .online-serve {
    width: px2rem(80, 375);
    position: absolute;
    top: px2rem(27, 375);
    right: 0;
    img {
      width: 100%;
    }
  }
</style>
